export default __webpack_public_path__ + "static/media/software-crm.e9e2e1c9.png";